import { observer } from 'mobx-react';

const AgentConversationStarter = observer(
  ({
    icon,
    title = 'Conversation Starter',
    description = 'Click to start a new conversation with the agent.',
    onClick = () => {},
    disabled = false
  }) => {
    return (
      <div
        className={`agent-conversation-starter${disabled ? ' disabled' : ''}`}
        role="button"
        tabIndex={disabled ? -1 : 0}
        onClick={disabled ? undefined : onClick}
        onKeyDown={disabled ? undefined : (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
        aria-disabled={disabled || undefined}
      >
        <div className="conversation-starter-icon">
          <img src={icon} alt={title} />
        </div>

        <h3 className="conversation-starter-title">
          {title}
        </h3>

        <p className="conversation-starter-description">
          {description}
        </p>
      </div>
    );
  }
);

export default AgentConversationStarter;